var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 93,
    viewBox: "0 0 135 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.739 86.4084C90.9118 89.137 79.4483 87.6717 69.6649 82.3086C59.8816 76.9455 52.5082 68.0846 49.035 57.5169C45.5618 46.9492 46.2479 35.4628 50.9545 25.3794C55.6612 15.2959 64.0374 7.36746 74.3902 3.19645C84.7429 -0.974559 96.3001 -1.07703 106.726 2.90974C117.152 6.89652 125.668 14.6752 130.555 24.6736C135.441 34.672 136.332 46.1444 133.049 56.772C129.765 67.3996 122.551 76.3898 112.866 81.9255L112.968 92.9993L101.739 86.4084Z",
    fill: "url(#paint0_linear_449_271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.889 81.1875C11.4643 75.3726 4.60135 66.2198 1.68126 55.5706C-1.23884 44.9215 0.000599384 33.5664 5.15017 23.7904C10.2997 14.0143 18.9773 6.54277 29.4366 2.87922C39.896 -0.784336 51.3609 -0.368015 61.5243 4.04441C71.6878 8.45683 79.7956 16.5379 84.2161 26.6615C88.6366 36.785 89.0419 48.1998 85.3503 58.6089C81.6588 69.0179 74.1443 77.6487 64.3191 82.7645C54.4939 87.8804 43.0872 89.1016 32.3941 86.1824L20.7803 93.0004L20.889 81.1875Z",
    fill: "url(#paint1_linear_449_271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875 43.8681C46.871 36.4429 48.7615 29.1383 52.3691 22.6396C55.9767 16.1409 61.1832 10.661 67.5003 6.71387C73.8146 10.664 79.0189 16.1446 82.6262 22.6426C86.2334 29.1407 88.1256 36.4437 88.1256 43.8682C88.1256 51.2927 86.2334 58.5957 82.6262 65.0938C79.0189 71.5919 73.8146 77.0724 67.5003 81.0225C61.1832 77.0754 55.9767 71.5954 52.3691 65.0967C48.7614 58.5979 46.871 51.2933 46.875 43.8681Z",
    fill: "url(#paint2_linear_449_271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0852 80.5553C45.4089 63.1054 30.8477 53.8623 30.8477 39.1598C30.8477 28.0419 39.0658 18.9277 50.3189 18.9277C58.129 18.9277 63.9225 23.5533 67.4994 30.1151C71.0759 23.5536 76.8705 18.9277 84.6799 18.9277C95.9343 18.9277 104.151 28.0437 104.151 39.1598C104.151 53.8604 89.6089 63.0894 68.9135 80.5551C68.5172 80.886 68.0165 81.0674 67.4992 81.0674C66.982 81.0674 66.4813 80.886 66.0849 80.5551L66.0852 80.5553Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_271",
    x1: 46.8496,
    y1: 46.4958,
    x2: 134.997,
    y2: 46.4958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2F97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797EF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_449_271",
    x1: 0.132812,
    y1: 46.7023,
    x2: 87.8526,
    y2: 46.7023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#797EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_449_271",
    x1: 46.875,
    y1: 43.8682,
    x2: 88.1256,
    y2: 43.8682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA7EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 93,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo_color.dec3b90e48cf5a4ea367ebf1ef5097bb.svg";
export { ForwardRef as ReactComponent };